import { UserIdSchema as m, PaymentTransactionIdSchema as t, DateTimeSchema as r } from "@hprofits/shared";
import { z as e } from "zod";
import { createCreationResultSchema as s } from "../common/creation-result.js";
import { PaginationSchema as i, ApiSortModeSchema as l, paginatedList as d } from "../common/pagination.js";
import { idListQueryParam as u } from "../common/params.js";
const o = 100, M = e.object({
  id: m,
  firstName: e.string(),
  lastName: e.string(),
  email: e.string(),
  isEmailVerified: e.boolean(),
  messenger: e.string().nullable(),
  messengerId: e.string().nullable(),
  isSubscribed: e.boolean(),
  balanceAlerts: e.boolean()
}).readonly(), x = e.object({
  firstName: e.string().trim().min(1).max(o),
  lastName: e.string().trim().min(1).max(o),
  messengerId: e.string().trim().max(o).nullable(),
  isSubscribed: e.boolean(),
  balanceAlerts: e.boolean()
}).strict().readonly(), y = 100, b = 25, A = 2, p = e.enum(["id", "createdAt", "approvedAt", "amount"]), U = i.extend({
  pageSize: e.coerce.number().int().min(1).max(y).default(b),
  sortBy: p.default("id"),
  sortDirection: l.default("desc"),
  ids: u(t).optional()
}).readonly(), S = e.object({
  id: t,
  createdAt: r.nullable(),
  approvedAt: r.nullable(),
  /** Whole US dollars. */
  amount: e.number(),
  invoiceId: e.int().positive().nullable(),
  failed: e.boolean()
}).readonly(), R = d(S), j = e.object({
  paymentId: e.coerce.number().pipe(t)
}).readonly(), v = 50, c = 1e5, O = 34, B = e.object({
  amount: e.int().min(-c).max(c).refine((n) => n !== 0, { error: "Amount cannot be zero" })
}).readonly(), Y = s(t), g = e.object({
  id: m,
  firstName: e.string(),
  lastName: e.string(),
  email: e.string()
}).readonly(), L = g.nullable(), h = e.object({
  /** US dollars; negative once the spend exceeds the payments. */
  amount: e.number(),
  currency: e.literal("USD")
}).readonly(), z = h.nullable(), N = e.string().trim().toUpperCase().length(A), a = e.string().trim().min(1), C = e.object({
  code: e.string(),
  name: e.string()
}).readonly(), D = e.array(C).readonly(), P = e.object({
  countryCode: e.string().nullable(),
  city: e.string(),
  streetAddress: e.string(),
  zipCode: e.string(),
  isCompany: e.boolean(),
  companyName: e.string().nullable(),
  vatTaxId: e.string().nullable()
}).readonly(), G = P.nullable(), X = e.object({
  countryCode: N,
  city: a,
  streetAddress: a,
  zipCode: a,
  isCompany: e.boolean(),
  companyName: a.nullable(),
  vatTaxId: a.nullable()
}).refine((n) => !n.isCompany || n.companyName !== null, {
  path: ["companyName"],
  error: "Company name is required for a company"
}).refine((n) => !n.isCompany || n.vatTaxId !== null, {
  path: ["vatTaxId"],
  error: "VAT number is required for a company"
}).readonly();
export {
  y as ACCOUNT_PAYMENTS_MAX_PAGE_SIZE,
  c as ACCOUNT_PAYMENT_MAX_AMOUNT,
  v as ACCOUNT_PAYMENT_MIN_AMOUNT,
  z as AccountBalanceResponseSchema,
  h as AccountBalanceSchema,
  L as AccountManagerResponseSchema,
  g as AccountManagerSchema,
  j as AccountPaymentIdParamSchema,
  S as AccountPaymentSchema,
  U as AccountPaymentsQuerySchema,
  R as AccountPaymentsResponseSchema,
  p as AccountPaymentsSortBySchema,
  M as AccountProfileSchema,
  D as BillingCountriesResponseSchema,
  C as BillingCountrySchema,
  Y as CreateAccountPaymentResultSchema,
  B as CreateAccountPaymentSchema,
  O as PAYMENT_BYPASS_MIN_GRANT,
  G as PaymentInformationResponseSchema,
  P as PaymentInformationSchema,
  x as UpdateAccountProfileSchema,
  X as UpdatePaymentInformationSchema
};
//# sourceMappingURL=schemas.js.map
